module.exports = __webpack_public_path__ + "img/br40.a339c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br40.jpg
// module id = 79/y
// module chunks = 0